module.exports = __webpack_public_path__ + "img/714.8a621df9.png";